<template>
  <div>
    <v-row justify="center">
      <v-col cols="12" md="10" lg="8">
        <v-card class="card--shadow">
          <v-card-title class="flex-wrap">
            <span class="mr-2">Presumptive</span>
            <v-spacer />
            <v-btn
              @click="viewPresumptiveReferral"
              class="ma-1"
              outlined
              color="teal accent-4"
              dark
            >
              <v-icon left dark>mdi-format-list-bulleted</v-icon>Presumptive
              Referral
            </v-btn>
            <v-btn
              @click="viewPresumptiveList"
              class="ma-1"
              outlined
              color="teal accent-4"
              dark
            >
              <v-icon left dark>mdi-format-list-bulleted</v-icon>Presumptive
              List
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col cols="12" sm="6" md="4">
                <label>Index Case Year</label>
                <v-text-field
                  v-model.trim="indexYear"
                  type="text"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <label>Index Case Code</label>
                <v-text-field
                  v-model.trim="indexCode"
                  type="text"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <label>Mono/Poly</label>
                <v-select
                  v-model="monopoly"
                  :items="monopolyOpt"
                  dense
                  outlined
                ></v-select>
              </v-col>
              <v-col cols="12" v-show="admin.township && admin.township.initial == 2">
                <label>Initial</label>
                <v-select
                  v-model="initial"
                  :items="initialOpt"
                  dense
                  outlined
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-card
                  outlined
                  class="outside-township-card pa-3"
                  elevation="0"
                >
                  <div
                    class="d-flex flex-column flex-sm-row flex-sm-wrap align-sm-center"
                  >
                    <div class="outside-township-label mr-sm-3 mb-2 mb-sm-0">
                      <v-icon small class="mr-1">mdi-map-marker-outline</v-icon>
                      Outside Township
                    </div>
                    <v-radio-group
                      v-model="outside_township"
                      class="outside-township-radio mt-0 flex-grow-0"
                      hide-details
                      dense
                      row
                    >
                      <v-radio label="No" value="1" color="teal accent-4"></v-radio>
                      <v-radio label="Yes" value="2" color="teal accent-4"></v-radio>
                    </v-radio-group>
                    <v-expand-transition>
                      <div
                        v-if="outside_township == 2"
                        class="mt-2 mt-sm-0 ml-sm-4 flex-grow-1"
                        style="min-width: 0"
                      >
                        <v-select
                          :items="outside_townships"
                          v-model="outside_township_id"
                          item-text="name"
                          item-value="id"
                          label="Select township"
                          dense
                          outlined
                          clearable
                          placeholder="Choose township"
                        >
                          <template v-slot:label>
                            <span>
                              Select township
                              <require-sign v-if="outside_township == 2" />
                            </span>
                          </template>
                        </v-select>
                      </div>
                    </v-expand-transition>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" class="text-center text-sm-left">
                <v-btn
                  height="40"
                  color="purple accent-4"
                  @click.prevent="searchPsp"
                  outlined
                  rounded
                  dark
                >
                  <v-icon left>mdi-magnify</v-icon>Search
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <div v-if="showList && !loading" class="mt-5">
          <v-card
            elevation="0"
            color="pink accent-1"
            class="pa-2 d-flex justify-center bg-pink"
            v-if="presumptiveData.length == 0"
          >
            <p class="noti-text white--text">
              <v-icon class="white--text mr-1"
                >mdi-clipboard-alert-outline</v-icon
              >Sorry, no match patients!
            </p>
          </v-card>
          <div v-else>
            <search-list />
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { ValidationMixin } from "./../../mixins/ValidationMixin";
import { required } from "vuelidate/lib/validators";
import SearchList from "@/components/presumptive/SearchList.vue";
import RequireSign from "@/components/notification/RequireSign.vue";
import { mapState, mapActions } from "vuex";

export default {
  mixins: [ValidationMixin],
  components: {
    SearchList,
    RequireSign,
  },
  data: () => ({
    showList: false,
    initialOpt: ["M", ""],
    monopolyOpt: ["No", "Yes", "SG"],
    initial: null,
    indexYear: null,
    monopoly: null,
    indexCode: null,
    outside_township: "1",
    outside_township_id: null,
  }),
  validations: {
    IndexYear: {
      required,
    },
    indexCode: {
      required,
    },
  },
  watch: {
    outside_township(val) {
      if (val === "2") {
        const tid = this.townshipIdForOutsideFetch();
        if (tid) this.getOutsideTownships(tid);
      } else {
        this.outside_township_id = null;
      }
    },
  },
  methods: {
    ...mapActions("InfoData", ["getOutsideTownships"]),
    townshipIdForOutsideFetch() {
      return (
        (this.admin && this.admin.township_id) ||
        this.$route.params.township_id ||
        this.$route.query.township_id ||
        null
      );
    },
    searchPsp() {
      if (
        this.outside_township === "2" &&
        (this.outside_township_id == null || this.outside_township_id === "")
      ) {
        this.$toast.error("Please select outside township");
        return;
      }
      const tid = this.townshipIdForOutsideFetch();
      let data = {
        index_case_no: this.indexCode,
        index_case_year: this.indexYear,
        index_case_monopoly: this.monopoly == "Yes" ? 2 : 1,
        index_case_initial: this.initial ? this.initial : "",
        outside_township: this.outside_township,
        ...(this.outside_township === "2" &&
          this.outside_township_id != null && {
            outside_township_id: this.outside_township_id,
          }),
      };
      if (tid) {
        data.township_id = tid;
      }

      this.showList = false;
      this.$store.dispatch("Presumptive/searchByIndexCode", data).then(() => {
        this.showList = true;
      });
    },

    viewPresumptiveList() {
      this.$router.push({
        name: "presumptive-list",
      });
    },
    viewPresumptiveReferral() {
      this.$router.push({
        name: "presumptive-referral",
      });
    },
  },
  computed: {
    ...mapState("Presumptive", ["presumptiveData"]),
    ...mapState("Admin", ["admin"]),
    ...mapState("Loading", ["loading"]),
    ...mapState("InfoData", ["outside_townships"]),
  },
};
</script>

<style scoped>
.noti-text {
  color: #ffffff;
  font-size: 18px;
  margin-top: 10px;
  margin-right: 10px;
  letter-spacing: 1px;
}

.outside-township-card {
  border-radius: 8px;
  border-color: rgba(0, 0, 0, 0.12);
  background-color: rgba(0, 150, 136, 0.04);
}

.outside-township-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.6);
}
</style>
